import * as React from "react";
import {
  Label,
  Checkbox,
  ICheckboxProps,
  ICheckboxStyles
} from "office-ui-fabric-react";

export interface AttachmentsProps {
  updateSelectedAttachmentList;
  isItemChanged: boolean;
}

export interface AttachmentsState {
  selectedAttachments: any[];
  isItemsSelected: boolean;
  isAllSelected: boolean;
}
let isMounted = false;
class Attachments extends React.Component<AttachmentsProps, AttachmentsState> {
  constructor(props, {}) {
    super(props, {});
    this.state = {
      isItemsSelected: true,
      selectedAttachments: [],
      isAllSelected: true
    };
  }
  componentDidMount() {
    isMounted = true;
    let { selectedAttachments } = this.state;
    //retrieve attachments of the selected mailbox item
    let attachments = Office.context.mailbox.item.attachments;
    attachments.forEach(attachment => {
      if (
        selectedAttachments.filter(x => x.key === attachment.id).length === 0
      ) {
        selectedAttachments.push({
          key: attachment.id,
          isChecked: true, //default keep all selected
          name: attachment.name,
          size: attachment.size,
          contentType: attachment.contentType
        });
      } else {
        selectedAttachments.find(x => x.key === attachment.id).isChecked = true;
      }
    });
    isMounted &&
      this.setState({
        selectedAttachments: selectedAttachments,
        isAllSelected: true
      });
  }
  componentWillUnmount() {
    isMounted = false;
  }
  componentWillReceiveProps(nextProps) {
    let { selectedAttachments } = this.state;
    let attachments = Office.context.mailbox.item.attachments;
    if (nextProps.isItemChanged) {
      attachments.forEach(attachment => {
        selectedAttachments.push({
          key: attachment.id,
          isChecked: true, //default keep all selected
          name: attachment.name,
          size: attachment.size,
          contentType: attachment.contentType
        });
      });
      isMounted &&
        this.setState({
          selectedAttachments: selectedAttachments,
          isAllSelected: true
        });
    }
  }
  render() {
    let attachments = this.getAttachments();
    let totalSize = this.getTotalAttachmentSize(attachments);
    const checkboxStyles = (): ICheckboxStyles => {
      return {
        root: {
          fontFamily: "Lato",
          fontWeight: "normal",
          color: "black",
          fontSize: 14
        }
      };
    };

    return (
      <div>
        <div className="ms-Grid-row">
          <div
            className="ms-Grid-col ms-sm12 ms-md12 ms-lg12"
            style={{ marginTop: 30 }}
          >
            <Label
              style={{
                fontFamily: "Lato",
                fontWeight: "normal",
                color: "black",
                fontSize: 16
              }}
            >
              Select Attachments
            </Label>
          </div>
        </div>
        {Office.context.mailbox.item.attachments.length === 0 && (
          <div className="ms-Grid-row" style={{ marginTop: "10px" }}>
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
              <Label
                style={{
                  fontFamily: "Lato",
                  fontWeight: "normal",
                  color: "#939799",
                  fontSize: 14
                }}
              >
                This email does not have any attachments.
              </Label>
            </div>
          </div>
        )}
        {Office.context.mailbox.item.attachments.length > 0 && (
          <div>
            <div className="ms-Grid-row" style={{ marginTop: "10px" }}>
              <div className="ms-Grid-col ms-sm10 ms-md10 ms-lg10">
                <span
                  style={{
                    fontFamily: "Lato",
                    fontWeight: "normal",
                    color: "black",
                    fontSize: 14
                  }}
                >
                  Name
                </span>
              </div>
              <div className="ms-Grid-col ms-sm2 ms-md2 ms-lg2">
                <span
                  style={{
                    fontFamily: "Lato",
                    fontWeight: "normal",
                    color: "black",
                    fontSize: 14,
                    float: "right",
                    paddingRight: "0px"
                  }}
                >
                  Size
                </span>
              </div>
            </div>
            <div className="ms-Grid-row" style={{ marginTop: "15px" }}>
              <div className="ms-Grid-col ms-sm10 ms-md10 ms-lg10">
                <Checkbox
                  label="Select All"
                  onChange={this.onSelectAllChange}
                  styles={checkboxStyles()}
                  checked={
                    this.state.isAllSelected || this.props.isItemChanged
                      ? true
                      : false
                  }
                />
              </div>
              <div className="ms-Grid-col ms-sm2 ms-md2 ms-lg2">
                <span
                  style={{
                    fontFamily: "Lato",
                    fontWeight: "normal",
                    color: "rgb(51, 51, 51)",
                    fontSize: 14,
                    float: "right",
                    paddingRight: "0px"
                  }}
                >
                  {totalSize}
                </span>
              </div>
            </div>
            {attachments.map((item, index) => (
              <div
                className="ms-Grid-row"
                style={{ marginTop: "20px" }}
                key={index}
              >
                <div className="ms-Grid-col ms-sm10 ms-md10 ms-lg10">
                  <Checkbox
                    label={item.name}
                    onChange={this.makeChangeHandler(item)}
                    styles={checkboxStyles()}
                    checked={this.isAttachmentSelected(item)}
                    defaultChecked={true}
                  />
                </div>
                <div className="ms-Grid-col ms-sm2 ms-md2 ms-lg2">
                  <span
                    style={{
                      fontFamily: "Lato",
                      fontWeight: "normal",
                      color: "rgb(51, 51, 51)",
                      fontSize: 14,
                      float: "right",
                      paddingRight: "0px"
                    }}
                  >
                    {item.size >= 1048576
                      ? this.formatSize(item.size) + "MB"
                      : this.formatSize(item.size) + "KB"}
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }
  //select all checkbox change
  onSelectAllChange = (
    _ev: React.FormEvent<HTMLElement>,
    isChecked: boolean
  ) => {
    let { selectedAttachments } = this.state;
    let attachments = Office.context.mailbox.item.attachments;
    attachments.forEach(attachment => {
      if (
        selectedAttachments.filter(x => x.key === attachment.id).length === 0
      ) {
        //if attachment is not in the selected list
        selectedAttachments.push({
          key: attachment.id,
          isChecked: isChecked ? true : false, //if checked keep all select else keep all unselect
          name: attachment.name,
          size: attachment.size,
          contentType: attachment.contentType
        });
      } else {
        //already in the selected attachment list
        selectedAttachments.find(
          x => x.key === attachment.id
        ).isChecked = isChecked ? true : false;
      }
    });
    isMounted &&
      this.setState({
        selectedAttachments: selectedAttachments,
        isAllSelected: isChecked ? true : false
      });
    this.props.updateSelectedAttachmentList(selectedAttachments);
  };
  //retrieve attachment list
  getAttachments = (): any[] => {
    let attachmentItems = [];
    let item = Office.context.mailbox.item;
    let attachments = item.attachments;
    if (item.itemType == Office.MailboxEnums.ItemType.Message) {
      attachmentItems = [];
      for (let i = 0; i < attachments.length; i++) {
        attachmentItems.push({
          key: attachments[i].id,
          name: attachments[i].name,
          size: attachments[i].size,
          type: attachments[i].contentType
        });
      }
    }
    return attachmentItems;
  };
  //get attachment size in KB or MB
  formatSize = bytes => {
    if (bytes == 0) return "0 Byte";
    let a: number;
    a = Math.floor(Math.log(bytes) / Math.log(1024));
    let i = Math.round(bytes / Math.pow(1024, a));
    return i;
  };

  //get the total attachments size
  getTotalAttachmentSize = (attachments): string => {
    let totalSize = 0;
    let result = "";
    try {
      attachments.forEach(attachment => {
        totalSize = totalSize + attachment.size;
      });
      result =
        totalSize >= 1048576
          ? this.formatSize(totalSize) + "MB"
          : this.formatSize(totalSize) + "KB";
    } catch (error) {
      console.error(error);
    }
    return result;
  };
  //render check box label
  onRenderCheckBoxlabel = (props: ICheckboxProps): JSX.Element => {
    return (
      <span
        style={{
          fontFamily: "Lato",
          fontWeight: "normal",
          color: "black",
          fontSize: 14,
          paddingLeft: 5
        }}
      >
        {props.label}
      </span>
    );
  };
  //check whether attachment is selected
  isAttachmentSelected = (item): boolean => {
    let { selectedAttachments } = this.state;
    if (selectedAttachments.filter(x => x.key === item.key).length > 0) {
      if (selectedAttachments.find(x => x.key === item.key).isChecked) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };
  //attachment checkbox change
  onChangeCheckBox = (
    _ev: React.FormEvent<HTMLElement>,
    isChecked: boolean,
    item: any
  ) => {
    let { selectedAttachments } = this.state;
    let isAllSelected = false;
    let allAttachments = Office.context.mailbox.item.attachments;
    if (selectedAttachments.filter(x => x.key === item.key).length === 0) {
      //if attachment is not in the selected list
      selectedAttachments.push({
        key: item.key,
        isChecked: isChecked ? true : false,
        name: item.name,
        size: item.size,
        contentType: item.contentType
      });
    } else {
      //already in the selected attachment list
      selectedAttachments.find(x => x.key === item.key).isChecked = isChecked
        ? true
        : false;
    }
    if (
      allAttachments.length ===
      selectedAttachments.filter(x => x.isChecked === true).length
    ) {
      //if all attachments are selected
      isAllSelected = true;
    } else {
      isAllSelected = false;
    }
    isMounted &&
      this.setState({
        selectedAttachments: selectedAttachments,
        isAllSelected: isAllSelected
      });
    this.props.updateSelectedAttachmentList(selectedAttachments);
  };

  makeChangeHandler = item => {
    return (ev: any, checked: boolean) =>
      this.onChangeCheckBox(ev, checked, item);
  };
}

export default Attachments;
